import React from "react";

import { observer } from "mobx-react";

import { Bet } from "@models";

import { useTranslation } from "react-i18next";

export const GainTaxPercentage = observer(function GainTaxPercentage(props: {
	bet: Bet;
}) {
	const { t } = useTranslation("mybets");
	const { bet } = props;

	if (!bet.gainTaxPercentage && !bet.gainTax) {
		return null;
	}

	return (
		<div className="bet__details__row">
			<div className="bet__details__col">
				{t("ITEM.ADDITIONAL_GAIN_TAX", {
					0: bet.gainTaxPercentage.toFixed(),
				})}
			</div>
			<div className="bet__details__col">{bet.displayGainTax}</div>
		</div>
	);
});
